import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: 'app-shop-profile',
  templateUrl: './shop-profile.component.html',
  styleUrls: ['./shop-profile.component.scss']
})
export class ShopProfileComponent implements OnInit {

  shop:any

  constructor(
    private authservice:AuthService,
    private router:Router
  ) { }

  
  ngOnInit() {
  let shop = JSON.parse(localStorage.getItem('USER'))
  this.shop = shop.info
  }

  


}




// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/shop/shop-profile/shop-profile.component.ts